(function () {
  'use strict';

  /* ============================================================
     KODIAK SPORTS - GLOBAL TURF CALCULATOR

     Each area card shows both roll options immediately.
     Customer selects Option 1 or Option 2 per area.
     Selected options flow to product table.

     Default roll width: 15 (overridden per product by data-roll-width)

     Option 1 - Lengthwise (rolls run parallel to length):
       numRolls   = ceil(areaWidth / rollWidth)
       rollLength = ceil(areaLength)
       kitSqFt    = numRolls * rollWidth * rollLength
       e.g. "2 - 15' x 50' Rolls = 1,500 sq ft"

     Option 2 - Widthwise (rolls run parallel to width):
       numRolls   = ceil(areaLength / rollWidth)
       rollLength = ceil(areaWidth)
       kitSqFt    = numRolls * rollWidth * rollLength
       e.g. "4 - 15' x 24' Rolls = 1,440 sq ft"
  ============================================================ */

  /*!
 * KODIAK SPORTS LLC — PROPRIETARY SOFTWARE
 * Copyright 2026 Kodiak Sports, LLC. All rights reserved.
 *
 * This calculator, including its user interface design, logic, architecture,
 * and implementation, is the exclusive intellectual property of Kodiak Sports, LLC.
 *
 * UNAUTHORIZED COPYING, REPRODUCTION, MODIFICATION, DISTRIBUTION, OR USE
 * OF THIS CODE OR ITS DESIGN — IN WHOLE OR IN PART — IS STRICTLY PROHIBITED
 * WITHOUT THE EXPRESS WRITTEN CONSENT OF KODIAK SPORTS, LLC.
 *
 * Violations will be pursued to the fullest extent of applicable intellectual
 * property, trade secret, and unfair competition laws, including but not limited
 * to claims for injunctive relief, actual damages, and attorney's fees.
 *
 * Kodiak Sports, LLC | Plano, TX | www.kodiaksports.com
 */

  var DEFAULT_ROLL_WIDTH = 15;

  var areas = {
    1: { length: 0, width: 0, direction: 'length' },
    2: { length: 0, width: 0, direction: 'length' },
    3: { length: 0, width: 0, direction: 'length' },
    4: { length: 0, width: 0, direction: 'length' }
  };

  // ── Feet/inches/fraction parser ────────────────────────────
  function parseFeet(raw) {
    if (!raw || raw === '') return 0;
    raw = raw.toString().trim();
    var fi = raw.match(/^(\d+(?:\.\d+)?)['\s\-](\d+(?:\.\d+)?)(?:")?$/);
    if (fi) return parseFloat(fi[1]) + parseFloat(fi[2]) / 12;
    var wf = raw.match(/^(\d+)\s+(\d+)\/(\d+)$/);
    if (wf) return parseInt(wf[1]) + parseInt(wf[2]) / parseInt(wf[3]);
    var fo = raw.match(/^(\d+)\/(\d+)$/);
    if (fo) return parseInt(fo[1]) / parseInt(fo[2]);
    var n = parseFloat(raw);
    return isNaN(n) ? 0 : n;
  }

  // ── Calculate one roll option ──────────────────────────────
  function calcOption(areaLength, areaWidth, rollWidth, direction) {
    if (areaLength <= 0 || areaWidth <= 0 || rollWidth <= 0) return null;

    var numRolls, rollLength, kitSqFt;

    if (direction === 'length') {
      numRolls   = Math.ceil(areaWidth / rollWidth);
      rollLength = Math.ceil(areaLength);
    } else {
      numRolls   = Math.ceil(areaLength / rollWidth);
      rollLength = Math.ceil(areaWidth);
    }

    kitSqFt = numRolls * rollWidth * rollLength;

    return {
      numRolls   : numRolls,
      rollLength : rollLength,
      rollWidth  : rollWidth,
      kitSqFt    : kitSqFt,
      displayNote: numRolls + " - " + rollWidth + "' x " + rollLength + "' Rolls = " + kitSqFt.toLocaleString() + " sq ft",
      cartNote   : numRolls + " - " + rollWidth + "' x " + rollLength + "' Rolls, Kit Size: " + kitSqFt + " Sq. Ft"
    };
  }

  // ── Update a single area card display ─────────────────────
  function updateAreaCard(areaNum) {
    var a   = areas[areaNum];
    var l   = a.length;
    var w   = a.width;

    var rawSqFtEl = document.querySelector('.tc-area-sqft[data-area="' + areaNum + '"]');
    var opt1El    = document.querySelector('.tc-area-opt1[data-area="' + areaNum + '"]');
    var opt2El    = document.querySelector('.tc-area-opt2[data-area="' + areaNum + '"]');

    if (l <= 0 || w <= 0) {
      a.sqft = 0;
      if (rawSqFtEl) rawSqFtEl.textContent = '--';
      if (opt1El)    opt1El.textContent = '--';
      if (opt2El)    opt2El.textContent = '--';
      return;
    }

    a.sqft = l * w;

    var opt1 = calcOption(l, w, DEFAULT_ROLL_WIDTH, 'length');
    var opt2 = calcOption(l, w, DEFAULT_ROLL_WIDTH, 'width');

    a.opt1 = opt1;
    a.opt2 = opt2;

    if (rawSqFtEl) rawSqFtEl.textContent = Math.round(a.sqft).toLocaleString() + ' sq ft';
    if (opt1El && opt1) opt1El.textContent = opt1.displayNote;
    if (opt2El && opt2) opt2El.textContent = opt2.displayNote;
  }

  // ── Recalculate all areas ──────────────────────────────────
  function recalcAreas() {
    var totalSqFt   = 0;
    var activeCount = 0;

    for (var i = 1; i <= 4; i++) {
      updateAreaCard(i);
      if (areas[i].sqft > 0) {
        totalSqFt += areas[i].sqft;
        activeCount++;
      }
    }

    var totalEl = document.getElementById('tc-total-sqft');
    if (totalEl) totalEl.textContent = Math.round(totalSqFt).toLocaleString();

    var activeEl = document.getElementById('tc-areas-active');
    if (activeEl) activeEl.textContent = activeCount;

    recalcProducts();
  }

  // ── Get combined rolls data for product table ──────────────
  // Uses per-area direction selection and per-product rollWidth
  function getCombinedRollsData(rollWidth) {
    var totalKitSqFt = 0;
    var cartParts    = [];
    var displayParts = [];
    var hasAny       = false;

    for (var i = 1; i <= 4; i++) {
      var a = areas[i];
      if (a.sqft > 0) {
        var result = calcOption(a.length, a.width, rollWidth, a.direction);
        if (result) {
          hasAny = true;
          totalKitSqFt += result.kitSqFt;
          cartParts.push('Area ' + i + ': ' + result.cartNote);
          displayParts.push('Area ' + i + ': ' + result.displayNote);
        }
      }
    }

    if (!hasAny) return null;

    return {
      totalKitSqFt : totalKitSqFt,
      cartNote     : cartParts.join(' | '),
      displayParts : displayParts
    };
  }

  // ── Recalculate product table rows ─────────────────────────
  function recalcProducts() {
    var rows = document.querySelectorAll('.tc-product-row');

    rows.forEach(function (row) {
      var rollWidth = parseInt(row.getAttribute('data-roll-width')) || DEFAULT_ROLL_WIDTH;
      var combined  = getCombinedRollsData(rollWidth);

      var rollsEl  = row.querySelector('.tc-rolls-output');
      var totalEl  = row.querySelector('.tc-total-display');
      var atcBtn   = row.querySelector('.tc-atc-btn');
      var selectEl = row.querySelector('.tc-variant-select');
      var priceEl  = row.querySelector('.tc-price-display');

      var price = 0;
      if (selectEl && selectEl.selectedOptions.length > 0) {
        price = parseFloat(selectEl.selectedOptions[0].getAttribute('data-price')) || 0;
      } else {
        price = parseFloat(row.getAttribute('data-first-price')) || 0;
      }

      if (priceEl) priceEl.textContent = price.toFixed(2);

      if (!combined || combined.totalKitSqFt <= 0) {
        if (rollsEl) rollsEl.innerHTML = '--';
        if (totalEl) { totalEl.textContent = '--'; totalEl.classList.remove('has-value'); }
        if (atcBtn)  atcBtn.disabled = true;
        return;
      }

      var totalPrice = combined.totalKitSqFt * price;

      if (rollsEl) {
        rollsEl.innerHTML = combined.displayParts.map(function (p) {
          return '<div>' + p + '</div>';
        }).join('');
      }

      if (totalEl) {
        totalEl.textContent = '$' + totalPrice.toFixed(2);
        totalEl.classList.add('has-value');
      }

      if (atcBtn) {
        atcBtn.disabled = false;
        atcBtn.setAttribute('data-sqft', combined.totalKitSqFt);
        atcBtn.setAttribute('data-rolls-note', combined.cartNote);
      }
    });
  }

  // ── Add to Cart ────────────────────────────────────────────
  function addToCart(btn) {
    var row       = btn.closest('.tc-product-row');
    var selectEl  = row.querySelector('.tc-variant-select');
    var variantId = selectEl ? parseInt(selectEl.value) : 0;
    var sqft      = parseInt(btn.getAttribute('data-sqft')) || 0;
    var rollsNote = btn.getAttribute('data-rolls-note') || '';

    if (!variantId || sqft <= 0) return;

    btn.classList.add('loading');
    btn.textContent = 'Adding...';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method : 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body   : JSON.stringify({
        id        : variantId,
        quantity  : sqft,
        properties: { 'Rolls': rollsNote }
      })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Cart error ' + res.status);
      return res.json();
    })
    .then(function () {
      btn.classList.remove('loading');
      btn.classList.add('added');
      btn.textContent = 'Added!';
      btn.disabled = false;

      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var els = document.querySelectorAll('.cart-count, #CartCount, .header-cart-count, [data-cart-count]');
          els.forEach(function (el) { el.textContent = cart.item_count; });
        });

      setTimeout(function () {
        btn.classList.remove('added');
        btn.textContent = 'Add to Cart';
      }, 3000);
    })
    .catch(function (err) {
      console.error('Add to cart error:', err);
      btn.classList.remove('loading');
      btn.textContent = 'Error - Retry';
      btn.disabled = false;
    });
  }

  // ── Event Listeners ────────────────────────────────────────
  function init() {
if (window.performance && window.performance.navigation.type === 2) { window.location.reload(); }
    // Length/Width inputs
    document.querySelectorAll('.tc-length, .tc-width').forEach(function (input) {
      input.addEventListener('input', function () {
        var areaNum  = parseInt(this.getAttribute('data-area'));
        var isLength = this.classList.contains('tc-length');
        var val      = parseFeet(this.value);
        if (isLength) {
          areas[areaNum].length = val;
        } else {
          areas[areaNum].width = val;
        }
        recalcAreas();
      });
    });

    // Direction buttons
    document.querySelectorAll('.tc-dir-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var areaNum  = parseInt(this.getAttribute('data-area'));
        var dir      = this.getAttribute('data-dir');
        var siblings = document.querySelectorAll('.tc-dir-btn[data-area="' + areaNum + '"]');
        siblings.forEach(function (s) { s.classList.remove('active'); });
        this.classList.add('active');
        areas[areaNum].direction = dir;
var card = document.querySelector('.tc-area-card[data-area="' + areaNum + '"]');
if (card) card.setAttribute('data-selected', dir);
recalcAreas();
      });
    });

    // Variant selects
    document.querySelectorAll('.tc-variant-select').forEach(function (sel) {
  sel.addEventListener('change', function () {
    var selectedOption = this.selectedOptions[0];
    var imgUrl = selectedOption.getAttribute('data-img');
    if (imgUrl && imgUrl !== 'null') {
      var row = this.closest('.tc-product-row');
      var img = row.querySelector('.tc-thumb img');
      if (img) img.src = imgUrl;
    }
    recalcProducts();
  });
});

   // Add to Cart
    document.addEventListener('click', function (e) {
      if (e.target && e.target.classList.contains('tc-atc-btn')) {
        addToCart(e.target);
      }
    });

    // ── MOBILE: Desktop banner dismiss ──
    var banner = document.querySelector('.tc-mobile-banner');
    var bannerClose = document.querySelector('.tc-mobile-banner__close');
    if (banner && bannerClose) {
      if (sessionStorage.getItem('tc-banner-dismissed')) {
        banner.classList.add('tc-hidden');
      }
      bannerClose.addEventListener('click', function () {
        banner.classList.add('tc-hidden');
        sessionStorage.setItem('tc-banner-dismissed', '1');
      });
    }

    // ── MOBILE: Add Another Area button ──
    var addAreaBtn = document.querySelector('.tc-add-area-btn');
    if (addAreaBtn) {
      var nextAreaToShow = 2;
      addAreaBtn.addEventListener('click', function () {
        var card = document.querySelector('.tc-area-card[data-area="' + nextAreaToShow + '"]');
        if (card) {
          card.classList.add('tc-mobile-visible');
          nextAreaToShow++;
        }
        if (nextAreaToShow > 4) {
          addAreaBtn.classList.add('tc-hidden');
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
// Lock qty inputs for roll kit items in ajax cart
(function() {
  function lockRollKitQtyInputs() {
    document.querySelectorAll('.ajaxifyCart--num').forEach(function(input) {

      // Walk up DOM to find a container that has "Rolls:" text
      var el = input.parentElement;
      var container = null;
      for (var i = 0; i < 10; i++) {
        if (!el) break;
        if (el.textContent.indexOf('Rolls:') !== -1) {
          container = el;
          break;
        }
        el = el.parentElement;
      }
      if (!container) return;

      // Lock the input
      input.setAttribute('readonly', 'readonly');
      input.style.pointerEvents = 'none';
      input.style.opacity = '0.6';

      // Hide +/- buttons (they're siblings inside .ajaxifyCart--qty)
      var qtyWrapper = input.closest('.ajaxifyCart--qty') || input.parentElement;
      var adjAdd   = qtyWrapper.querySelector('.ajaxifyCart--add');
      var adjMinus = qtyWrapper.querySelector('.ajaxifyCart--minus');
      if (adjAdd)   adjAdd.style.display   = 'none';
      if (adjMinus) adjMinus.style.display = 'none';
    });
  }

  var observer = new MutationObserver(function() {
    lockRollKitQtyInputs();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();

/* ============================================================
   KODIAK TURF CALCULATOR — FACET FILTER (filter-only, additive)
   AT-style multi-group filter, skinned to .tc-. Hides existing
   <tr.tc-product-row> nodes only (display:none), so the calculator
   above keeps computing on every row. OR within a group, AND across
   groups. Color group uses the Halo Designer color chart.
   Requires: rows carry data-tags + data-colors; the facet bar markup
   (.tc-facets / #tc-color-facets / #tc-active-row / #tc-clear-all)
   and the .tc-no-results row exist in the section.
   Context-agnostic: works identically on a page or collection template.
   ============================================================ */
(function () {
  'use strict';
  var COLOR_HEX = {
    'Green':'#2b623e','Black':'#101012','Red':'#c0202a','Florida Blue':'#0353a4',
    'Orange':'#e6611a','White':'#ffffff','Maroon':'#6e1b2c','Yellow':'#f2c200','Clay':'#b06a3a',
    'Gray':'#8a8d8f','Blue':'#1e5aa8','Navy Blue':'#1b2b4b','Lagoon Blue':'#2a9d8f',
    'Orange w Black/Gray Thatch':'#e6611a'
  };
  var COLOR_ORDER = [
    'Green','Black','Florida Blue','Red','Navy Blue','Orange','Gray',
    'Orange w Black/Gray Thatch','Yellow','White'
  ];
  function colorRank(c){ var i = COLOR_ORDER.indexOf(c); return i === -1 ? COLOR_ORDER.length : i; }
  function ready(fn){ if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',fn); else fn(); }
  ready(function(){
    var facets = document.querySelector('.tc-facets');
    var table  = document.querySelector('.tc-table');
    if(!facets || !table) return;
    var tbody = table.querySelector('tbody');
    var rows  = Array.prototype.slice.call(tbody.querySelectorAll('.tc-product-row'));
    if(!rows.length) return;

    rows.forEach(function(row){
      row._tcTags = (row.getAttribute('data-tags')||'').split(',').map(function(s){return s.trim();}).filter(Boolean);
      var cols = (row.getAttribute('data-colors')||'').split('|').map(function(s){return s.trim();}).filter(function(s){return s && COLOR_HEX[s];});
      var seen={}, uniq=[]; cols.forEach(function(c){ if(!seen[c]){seen[c]=1;uniq.push(c);} });
      row._tcColors = uniq;
    });

    var colorHost = document.getElementById('tc-color-facets');
    var union=[], uSeen={};
    rows.forEach(function(r){ r._tcColors.forEach(function(c){ if(!uSeen[c]){uSeen[c]=1;union.push(c);} }); });
    union.sort(function(a,b){ var d = colorRank(a) - colorRank(b); return d !== 0 ? d : a.localeCompare(b); });
    if(colorHost){
      if(!union.length){ var cr=colorHost.closest('.tc-facet-row'); if(cr) cr.style.display='none'; }
      else union.forEach(function(c){
        var b=document.createElement('button');
        b.type='button'; b.className='tc-facet-pill';
        b.setAttribute('data-group','color'); b.setAttribute('data-tag',c);
        b.innerHTML='<span class="tc-swatch" style="background:'+COLOR_HEX[c]+'"></span>'+c;
        colorHost.appendChild(b);
      });
    }

    var active = { usage:[], padding:[], color:[] };
    var countEl = document.querySelector('.tc-section-header__count');
    var baseCount = rows.length;
    var noRes = tbody.querySelector('.tc-no-results');
    var activeRow = document.getElementById('tc-active-row');
    var activePills = document.getElementById('tc-active-pills');

    function labelFor(g, tag){
      if(g==='usage') return tag.replace('USAGE_','');
      if(g==='padding') return tag.replace('PADDING_','');
      return tag;
    }
    function cssEsc(s){ return (window.CSS && CSS.escape) ? CSS.escape(s) : s.replace(/["\\]/g,'\\$&'); }

    function renderActive(any){
      if(!activeRow || !activePills) return;
      activePills.innerHTML='';
      if(!any){ activeRow.hidden=true; return; }
      activeRow.hidden=false;
      Object.keys(active).forEach(function(g){
        active[g].forEach(function(tag){
          var b=document.createElement('button');
          b.type='button'; b.className='tc-facet-pill tc-facet-pill--remove active';
          b.innerHTML=(g==='color'?'<span class="tc-swatch" style="background:'+(COLOR_HEX[tag]||'#999')+'"></span>':'')+labelFor(g,tag)+' \u00d7';
          b.addEventListener('click',function(){
            var src=facets.querySelector('.tc-facet-pill[data-group="'+g+'"][data-tag="'+cssEsc(tag)+'"]');
            toggle(g,tag,src||null);
          });
          activePills.appendChild(b);
        });
      });
    }

    function apply(){
      var visible=0;
      rows.forEach(function(r){
        var match = Object.keys(active).every(function(g){
          if(!active[g].length) return true;
          if(g==='color') return active[g].some(function(c){ return r._tcColors.indexOf(c)!==-1; });
          return active[g].some(function(t){ return r._tcTags.indexOf(t)!==-1; });
        });
        r.classList.toggle('tc-filtered-out', !match);
        if(match){ r.classList.toggle('tc-alt', visible % 2 === 1); visible++; }
        else { r.classList.remove('tc-alt'); }
      });
      var any = Object.keys(active).some(function(g){ return active[g].length>0; });
      if(countEl) countEl.textContent = any ? (visible+' of '+baseCount+' turf products shown') : (baseCount+' turf products shown');
      if(noRes) noRes.style.display = visible===0 ? '' : 'none';
      renderActive(any);
    }

    function toggle(g, tag, pillEl){
      var arr=active[g], i=arr.indexOf(tag);
      if(i===-1){ arr.push(tag); if(pillEl) pillEl.classList.add('active'); }
      else { arr.splice(i,1); if(pillEl) pillEl.classList.remove('active'); }
      apply();
    }
    function clearAll(){
      Object.keys(active).forEach(function(g){ active[g]=[]; });
      facets.querySelectorAll('.tc-facet-pill[data-group]').forEach(function(p){ p.classList.remove('active'); });
      apply();
    }

    facets.addEventListener('click', function(e){
      var pill = e.target.closest('.tc-facet-pill[data-group]');
      if(!pill) return;
      toggle(pill.getAttribute('data-group'), pill.getAttribute('data-tag'), pill);
    });
    var clearBtn = document.getElementById('tc-clear-all');
    if(clearBtn) clearBtn.addEventListener('click', clearAll);
    if(noRes){ var rl=noRes.querySelector('.tc-reset-link'); if(rl) rl.addEventListener('click', clearAll); }

    apply();
  });
})();
